// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OwlCz","top":"styles_top__3ocEU"};